import { UnknownAction } from 'redux';

export type MapRouterActionType = 'navigate_map';

export interface MapRouterAction extends UnknownAction {
  type: MapRouterActionType;
  path: string;
}

export const navigateAction = (path: string): MapRouterAction => ({
  type: 'navigate_map',
  path,
});
